import styled from 'styled-components';
import { Vehicle } from '../../../../../types/vehicle';
import { ImageComponent } from '../ImageComponent';
import { InfoComponent } from '../InfoComponent';
import { Actions } from '../Actions';
import { MilesInfo } from '../MilesInfo';
import { MobileVehicleCardProps } from './types';
import { usePortraitItems } from './useInfoItems';

const Wrapper = styled.div`
  display: flex;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  background: #fff;
  padding: 4px;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  /* Stacking context below the fixed page header so the image banner
     doesn't paint over it on scroll. */
  position: relative;
  z-index: 0;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  color: #000;
`;

const MainContent = styled.div`
  display: flex;
  gap: 2px;
  width: 100%;
`;

export const MobileVehicleCardPortrait = ({ vehicle }: MobileVehicleCardProps) => {
  const infoItems = usePortraitItems(vehicle)
  
  return (
    <Wrapper>
      <Title>{`${vehicle.year} ${vehicle.make} ${vehicle.model}`}</Title>
      <MainContent>
        <ImageComponent vehicle={vehicle} />
        <InfoComponent items={infoItems} />
      </MainContent>
      <div />
      <MilesInfo vehicle={vehicle} />
      <Actions vehicle={vehicle} />
    </Wrapper>
  );
};
